import type { EntityResponse } from '~/@types'
import { API_URL } from '~/constants/environment'

import { AppApi } from '../utils/api'
import type { ChatMedia } from './@types'

const chats = new AppApi(API_URL, 'v1/chats')

export const fetchChatMedia = async (id: string, mediaId: ChatMedia['id']) => {
  const response = await chats.get<EntityResponse<ChatMedia>>({
    path: `${id}/media?media_id=${mediaId}`,
  })
  return response.data
}
